import IconButton from "@material-ui/core/IconButton"
import Tooltip from "@material-ui/core/Tooltip"
import Badge from "@material-ui/core/Badge"
import { Theme, makeStyles, useTheme } from "@material-ui/core"
import { MessageSquare } from "react-feather"
import { Link } from "react-router-dom"

import { useTranslations } from "./use-translations"
import { useUrlWithContext } from "../../../hooks/use-url-with-context"
import { paths } from "../../../paths"
import { TaskViewModel } from "../../api/task"
import { MAX_SHOWN_UNREAD_COUNT, useEntityChatUnreadCount } from "../../../chat/hooks/use-entity-chat-unread-count"

const TaskChatButton = ({ task }: { task: TaskViewModel }) => {
  const classes = useStyles()
  const theme = useTheme()
  const translations = useTranslations()
  const { createPathWithContext } = useUrlWithContext()

  const canViewChat = Boolean(task.canViewTaskChat)
  const unreadCount = useEntityChatUnreadCount({ type: "task", entityId: task.id, skip: !canViewChat })

  if (!canViewChat) return null

  return (
    <Tooltip title={translations.chatLabel}>
      <IconButton
        component={Link}
        to={createPathWithContext(paths.taskChat(task.id))}
        aria-label={translations.chatLabel}
        style={{ color: theme.palette.text.primary }}
      >
        <Badge
          overlap="circular"
          color="primary"
          max={MAX_SHOWN_UNREAD_COUNT}
          badgeContent={unreadCount}
          classes={{ badge: classes.badge }}
        >
          <MessageSquare size={16} />
        </Badge>
      </IconButton>
    </Tooltip>
  )
}

const useStyles = makeStyles((theme: Theme) => ({
  // The icon is only 16px, so the badge has to be small and pushed out to the
  // corner to sit beside it rather than on top of it.
  badge: {
    height: 14,
    minWidth: 14,
    padding: theme.spacing(0, 0.375),
    fontSize: 9,
    fontWeight: 600,
    lineHeight: 1,
    transform: "scale(1) translate(65%, -65%)",
  },
}))

export default TaskChatButton
